var _rect, _rect2, _rect3, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPromptHireSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "url(#paint0_linear_449_1439)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 23.5,
    rx: 5.75,
    stroke: "white",
    strokeOpacity: 0.32,
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_449_1439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2503 17.4307H7.39314C7.23534 17.4307 7.10742 17.5586 7.10742 17.7164C7.10742 17.8742 7.23534 18.0021 7.39314 18.0021H10.2503C10.4081 18.0021 10.536 17.8742 10.536 17.7164C10.536 17.5586 10.4081 17.4307 10.2503 17.4307Z",
    fill: "#757582"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2478 16.2842H9.67634C9.51854 16.2842 9.39062 16.4121 9.39062 16.5699C9.39062 16.7277 9.51854 16.8556 9.67634 16.8556H10.2478C10.4056 16.8556 10.5335 16.7277 10.5335 16.5699C10.5335 16.4121 10.4056 16.2842 10.2478 16.2842Z",
    fill: "#EEEEF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.53599 16.2842H7.39314C7.23534 16.2842 7.10742 16.4121 7.10742 16.5699C7.10742 16.7277 7.23534 16.8556 7.39314 16.8556H8.53599C8.69379 16.8556 8.82171 16.7277 8.82171 16.5699C8.82171 16.4121 8.69379 16.2842 8.53599 16.2842Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2503 15.1416H7.39314C7.23534 15.1416 7.10742 15.2695 7.10742 15.4273C7.10742 15.5851 7.23534 15.713 7.39314 15.713H10.2503C10.4081 15.713 10.536 15.5851 10.536 15.4273C10.536 15.2695 10.4081 15.1416 10.2503 15.1416Z",
    fill: "#B9B9C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2492 13.999H9.96345C9.80565 13.999 9.67773 14.1269 9.67773 14.2847C9.67773 14.4425 9.80565 14.5705 9.96345 14.5705H14.2492C14.407 14.5705 14.5349 14.4425 14.5349 14.2847C14.5349 14.1269 14.407 13.999 14.2492 13.999Z",
    fill: "#EEEEF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.82171 13.999H7.39314C7.23534 13.999 7.10742 14.1269 7.10742 14.2847C7.10742 14.4425 7.23534 14.5705 7.39314 14.5705H8.82171C8.9795 14.5705 9.10742 14.4425 9.10742 14.2847C9.10742 14.1269 8.9795 13.999 8.82171 13.999Z",
    fill: "#B9B9C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9648 12.8564H14.2506C14.0928 12.8564 13.9648 12.9844 13.9648 13.1422C13.9648 13.3 14.0928 13.4279 14.2506 13.4279H15.9648C16.1226 13.4279 16.2506 13.3 16.2506 13.1422C16.2506 12.9844 16.1226 12.8564 15.9648 12.8564Z",
    fill: "#B9B9C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1085 12.8564H10.8228C10.665 12.8564 10.5371 12.9844 10.5371 13.1422C10.5371 13.3 10.665 13.4279 10.8228 13.4279H13.1085C13.2663 13.4279 13.3943 13.3 13.3943 13.1422C13.3943 12.9844 13.2663 12.8564 13.1085 12.8564Z",
    fill: "#757582"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.67885 12.8564H7.39314C7.23534 12.8564 7.10742 12.9844 7.10742 13.1422C7.10742 13.3 7.23534 13.4279 7.39314 13.4279H9.67885C9.83665 13.4279 9.96456 13.3 9.96456 13.1422C9.96456 12.9844 9.83665 12.8564 9.67885 12.8564Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5352 11.7139H12.8209C12.6631 11.7139 12.5352 11.8418 12.5352 11.9996C12.5352 12.1574 12.6631 12.2853 12.8209 12.2853H16.5352C16.693 12.2853 16.8209 12.1574 16.8209 11.9996C16.8209 11.8418 16.693 11.7139 16.5352 11.7139Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6777 11.7139H9.96345C9.80565 11.7139 9.67773 11.8418 9.67773 11.9996C9.67773 12.1574 9.80565 12.2853 9.96345 12.2853H11.6777C11.8355 12.2853 11.9634 12.1574 11.9634 11.9996C11.9634 11.8418 11.8355 11.7139 11.6777 11.7139Z",
    fill: "#EEEEF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.82171 11.7139H7.39314C7.23534 11.7139 7.10742 11.8418 7.10742 11.9996C7.10742 12.1574 7.23534 12.2853 7.39314 12.2853H8.82171C8.9795 12.2853 9.10742 12.1574 9.10742 11.9996C9.10742 11.8418 8.9795 11.7139 8.82171 11.7139Z",
    fill: "#757582"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1077 10.5713H14.2506C14.0928 10.5713 13.9648 10.6992 13.9648 10.857C13.9648 11.0148 14.0928 11.1427 14.2506 11.1427H17.1077C17.2655 11.1427 17.3934 11.0148 17.3934 10.857C17.3934 10.6992 17.2655 10.5713 17.1077 10.5713Z",
    fill: "#EEEEF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2503 10.5713H7.39314C7.23534 10.5713 7.10742 10.6992 7.10742 10.857C7.10742 11.0148 7.23534 11.1427 7.39314 11.1427H10.2503C10.4081 11.1427 10.536 11.0148 10.536 10.857C10.536 10.6992 10.4081 10.5713 10.2503 10.5713Z",
    fill: "#B9B9C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1077 9.42871H14.2506C14.0928 9.42871 13.9648 9.55663 13.9648 9.71443C13.9648 9.87222 14.0928 10.0001 14.2506 10.0001H17.1077C17.2655 10.0001 17.3934 9.87222 17.3934 9.71443C17.3934 9.55663 17.2655 9.42871 17.1077 9.42871Z",
    fill: "#757582"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2494 9.42871H8.82087C8.66307 9.42871 8.53516 9.55663 8.53516 9.71443C8.53516 9.87222 8.66307 10.0001 8.82087 10.0001H10.2494C10.4072 10.0001 10.5352 9.87222 10.5352 9.71443C10.5352 9.55663 10.4072 9.42871 10.2494 9.42871Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.67885 9.42871H7.39314C7.23534 9.42871 7.10742 9.55663 7.10742 9.71443C7.10742 9.87222 7.23534 10.0001 7.39314 10.0001H7.67885C7.83665 10.0001 7.96456 9.87222 7.96456 9.71443C7.96456 9.55663 7.83665 9.42871 7.67885 9.42871Z",
    fill: "#EEEEF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5346 8.28613H15.106C14.9482 8.28613 14.8203 8.41405 14.8203 8.57185C14.8203 8.72964 14.9482 8.85756 15.106 8.85756H16.5346C16.6924 8.85756 16.8203 8.72964 16.8203 8.57185C16.8203 8.41405 16.6924 8.28613 16.5346 8.28613Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.966 8.28613H11.6802C11.5224 8.28613 11.3945 8.41405 11.3945 8.57185C11.3945 8.72964 11.5224 8.85756 11.6802 8.85756H13.966C14.1238 8.85756 14.2517 8.72964 14.2517 8.57185C14.2517 8.41405 14.1238 8.28613 13.966 8.28613Z",
    fill: "#B9B9C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.536 8.28613H7.39314C7.23534 8.28613 7.10742 8.41405 7.10742 8.57185C7.10742 8.72964 7.23534 8.85756 7.39314 8.85756H10.536C10.6938 8.85756 10.8217 8.72964 10.8217 8.57185C10.8217 8.41405 10.6938 8.28613 10.536 8.28613Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0021 7.14355H11.0671C10.9308 7.14355 10.8203 7.27147 10.8203 7.42927C10.8203 7.58706 10.9308 7.71498 11.0671 7.71498H16.0021C16.1384 7.71498 16.2489 7.58706 16.2489 7.42927C16.2489 7.27147 16.1384 7.14355 16.0021 7.14355Z",
    fill: "#EEEEF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.96456 7.14355H7.39314C7.23534 7.14355 7.10742 7.27147 7.10742 7.42927C7.10742 7.58706 7.23534 7.71498 7.39314 7.71498H9.96456C10.1224 7.71498 10.2503 7.58706 10.2503 7.42927C10.2503 7.27147 10.1224 7.14355 9.96456 7.14355Z",
    fill: "#757582"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2503 6H7.39314C7.23534 6 7.10742 6.12792 7.10742 6.28571C7.10742 6.44351 7.23534 6.57143 7.39314 6.57143H14.2503C14.4081 6.57143 14.536 6.44351 14.536 6.28571C14.536 6.12792 14.4081 6 14.2503 6Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_449_1439",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_449_1439"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.2857,
    height: 12,
    fill: "white",
    transform: "translate(7.10938 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromptHireSymbol);
export default __webpack_public_path__ + "static/media/promptHireSymbol.4208ec6b0baeec78c28f700b9722686e.svg";
export { ForwardRef as ReactComponent };